<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>
      {{dialogTitle}}
    </h2>
    <div class="ya-dialog-content">
      <p>
        {{dialogContent}}
      </p>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="navigateToRegister()"><span
                langkey="phLoginDialog_Register"></span></button>
          </div>
          <div class="ya-button-container">
            <button mat-stroked-button (click)="navigateToLogin()"><span langkey="phLoginDialog_Login"></span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="term-container">
    <div class="term-nav">
      <ng-container *ngFor="let term of terms">
        <a a11y_Link (click)="navigateToTerms(term.id)">{{term.label}}</a>
      </ng-container>
    </div>
  </div>
</div>